import ActiveRecord from './active_record/base'
import {date} from '@eitje/utils'

class Excel extends ActiveRecord {
	static tableName = 'export2Excels'

	startDate() {
		const {date_range} = this
		return date(date_range.start_date)
	}
	endDate() {
		const {date_range} = this
		return date(date_range.end_date)
	}

	async exportAgain() {
		const res = await this.resourceReq('export_again', {method: 'post'})
		if (res.ok) await this.modelConfig?.exportAgainOnSuccess?.(res)
		return res
	}
}

export default Excel
